<ol class="list-unstyled small">
  <li class="d-inline-block text-secondary">
    {{ 'navigation.pages' | translate }}
  </li>
  @for (item of items(); track $index) {
    <li class="d-inline-block">
      <a [routerLink]="item.route">{{ item.label | translate }}</a>
    </li>
  }
</ol>
